// De twee LevelLeven programmavarianten.
// LevelLeven START (12 weken) is een afgerond programma op zichzelf.
// VERDER is een mogelijk, niet automatisch vervolg; specificaties nog niet vastgesteld.

export const PROGRAMMAS = {
  start: {
    key: "start",
    label: "START",
    ondertitel: "12 weken",
    korteOmschrijving: "Twaalf weken om weer in beweging te komen.",
    duur: "12 weken",
    intensiteit: "Intensief groepsprogramma met persoonlijke aandacht",
    groep: "20–22 deelnemers (max. 24)",
    begeleiding: "2 trainers per groep",
    accent: "#E06B3F",
    voor: {
      deelnemer:
        "Voor jou als je merkt dat het al even niet meer loopt. Twaalf weken om weer contact te maken met wat wél werkt.",
      opdrachtgever:
        "Voor inwoners die langdurig stilstaan, meerdere belemmeringen ervaren en onvoldoende aansluiting vinden bij bestaande trajecten. Aanvullend op wat er al is.",
    },
    focus: ["Startpunt", "Rugzak", "Rem", "Vonk", "Speelruimte", "LevelMoment", "Volgende beweging"],
    resultaat: {
      deelnemer:
        "Je weet beter waar je staat, wat je remt, wat je wél kunt en welke volgende stap bij jou past.",
      opdrachtgever:
        "Zicht op ontwikkeling in eigen regie, vaardigheden en veerkracht, en een passende vervolgstap. Start-, tussen- en eindmeting. De effectiviteit van de aanpak wordt nog onderzocht.",
    },
    kosten: "Circa €5.000 p.p. (indicatief)",
    fases: [
      { n: "Week 1-3", t: "Startpunt & Rugzak", d: "Kennismaken en het vertrekpunt vastleggen. Wat neem je mee?" },
      { n: "Week 4-6", t: "Rem", d: "Zelfinzicht en bewustwording: benoemen wat vastzet, in gedachten, gewoontes en omstandigheden." },
      { n: "Week 7-9", t: "Vonk & Speelruimte", d: "Nieuwe vaardigheden ervaren en oefenen. Veerkracht en eigen regie versterken." },
      { n: "Week 10-12", t: "LevelMoment & Volgende beweging", d: "Terugblik en eindmeting. Samen een passende volgende stap bepalen." },
    ],
  },
  verder: {
    key: "verder",
    label: "VERDER",
    ondertitel: "mogelijk vervolg",
    korteOmschrijving: "Een mogelijk vervolg. Geen automatische voortzetting.",
    duur: "Nog niet vastgesteld",
    intensiteit: "Nog niet vastgesteld",
    groep: "Nog niet vastgesteld",
    begeleiding: "Nog niet vastgesteld",
    accent: "#78A85A",
    voor: {
      deelnemer:
        "Soms is na START meer tijd nodig. Dan kijken we samen met je gemeente wat past. Dat kan VERDER zijn, maar ook iets anders.",
      opdrachtgever:
        "Een mogelijk vervolg voor deelnemers die na START meer tijd nodig hebben. Alleen in overleg met de gemeente. Duur, intensiteit en prijs worden nog uitgewerkt.",
    },
    focus: ["Verdieping van Speelruimte, LevelMoment en Volgende beweging"],
    resultaat: {
      deelnemer:
        "De beweging uit START verder vasthouden, in je eigen tempo.",
      opdrachtgever:
        "Het beoogde doel is behoud van ontwikkeling en een stevige aansluiting op participatie, scholing, begeleiding of werk. Invulling volgt na bevestigde specificaties.",
    },
    kosten: "Nog niet vastgesteld",
    fases: [
      { n: "Na START", t: "Gezamenlijk besluit", d: "Gemeente, deelnemer en LevelLeven kijken samen of verdieping nodig is." },
      { n: "Invulling", t: "In uitwerking", d: "Duur, intensiteit en prijs van VERDER zijn nog niet vastgesteld." },
    ],
  },
};

export const PROGRAMMA_KEYS = ["start", "verder"];
